module.exports = __webpack_public_path__ + "static/caGif-cc6be8dc0632ad7d1745fe56b32836d7.gif";